import React, { useState, useContext } from 'react';
import { IndexContext } from '../../context'

const Pricing = ({ pricingSection, isTrialAvailable, action }) => {
  const { baseUrl, isLogged } = useContext(IndexContext);
  const [pricingItemInput, setItem] = useState('advanced-bussines');

  const handleChange = e => setItem(e.target.id);

  const handlePriceLabel = value => {
    if (+value === 1) {
      return <span className="index-plan-item-digit" children={value}/>
    } else if (+value === 0) {
      return <span className="index-plan-item-text">Unlimited</span>
    } else if (+value > 1) {
      return (
        <React.Fragment>
          <span className="index-plan-item-text">Up to</span>
          <span className="index-plan-item-digit" children={value}/>
        </React.Fragment>
      );
    }
  };

  return (
    <section className="index-pricing" id="index-pricing">
      <h2 className="index-heading-blue index-pricing-heading">Pricing</h2>
      <div className="index-pricing-block">
        <div className="index-plan-info-labels">
          <div className="index-plan-info-label-empty"/>
          <div className="index-plan-info-label">Aircraft & Other Resources</div>
          <div className="index-plan-info-label">Instructors, Pilots & Other Users</div>
          <div className="index-plan-info-label">Locations (Airport, Office, etc.)</div>
        </div>
        <div className="index-pricing-inner">
          {pricingSection.map((el, index) => (
            <div className="index-pricing-item" key={index}>
              <input
                type="radio"
                name="pricingItemInput"
                id={el.unique}
                onChange={handleChange}
                className="index-pricing-item-input"
                checked={pricingItemInput === el.unique}
              />
              <label htmlFor={el.unique} className="index-pricing-inner-plan-label">
                <span className="index-pricing-inner-plan-name" children={el.name}/>
                <svg
                  width="21px"
                  height="21px"
                  className="svg-sprite index-pricing-inner-plan-icon"
                >
                  <use href={baseUrl + "/public/images/shapes.svg?v=#arrow-top-thin"}/>
                </svg>
              </label>
              <div className="index-pricing-inner-plan-info-wrap">
                <div className="index-pricing-item-block">
                  <div className="index-plan-section-label">Aircraft & Other Resources</div>
                  <div children={handlePriceLabel(el.maxAircrafts)}/>
                </div>
                <div className="index-pricing-item-block">
                  <div className="index-plan-section-label">
                    Instructors, Pilots &amp; Other Users
                  </div>
                  <div children={handlePriceLabel(el.maxUsers)}/>
                </div>
                <div className="index-pricing-item-block">
                  <div className="index-plan-section-label">
                    Locations (Airport, Office, etc.)
                  </div>
                  <div children={handlePriceLabel(el.maxLocations)}/>
                </div>
                <div className="index-pricing-item-block-price">
                  <div className="index-pricing-item-block-price-inner">
                    <div className="index-price-value">
                      <b className="index-price-value-bold">{'$' + el.price}</b>
                      <small className="index-price-per-month">per month</small>
                    </div>
                    <div className="index-price-or">or</div>
                    <div className="index-price-value">
                      <span className="index-price-value-normal">{'$' + +el.price * 11}</span>
                      <small className="index-price-per-month">per year</small>
                    </div>
                  </div>
                  <span>
                    {isLogged && action !== "edit" ? (
                      <span>
                        <a className="btn-blue-border index-price-buy-btn" href={`${baseUrl}/payments/payplan/${el.unique}/`}>
                          {isTrialAvailable === '1' ? "Start Free Trial" : "Buy now!"}
                        </a>{' '}
                      </span>) :
                      (<a className="btn-blue-border index-price-buy-btn" href={`${baseUrl}/authorization/`}>
                          Sign in &amp; Buy now!
                       </a>
                    )}
                  <div className="index-price-save">
                    Save
                    <span className="index-price-save-summ">{'$' + el.price}</span>
                  </div>
                  </span>
                </div>
              </div>
            </div>)
          )}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
